module.exports = __webpack_public_path__ + "static/media/favicon-hkstp608.d3519025.ico";